ui-cms-fullscreen-teaser {
  display: block;

  a {
    color: inherit;
    text-decoration: none;
  }

  sd-teaser-media {
    overflow: hidden;

    &::part(meta),
    &::part(headline),
    &::part(expandable) {
      margin-bottom: 0;
    }
  }

  .fullscreen-teaser {
    &--align-center {
      &::part(content),
      .sd-prose {
        text-align: center;
      }

      .sd-headline {
        justify-content: center;
      }
    }

    &__chevron-wrapper {
      display: flex;
    }

    &__chevron {
      margin: 0 auto;
      font-size: 24px;
      transition: 0.2s;

      &--opened {
        transform: rotate(180deg);
      }
    }

    &__image {
      height: 100%;

      img {
        height: 100%;
        object-fit: cover;
      }
    }

    &--expandable-visible {
      &::part(expandable) {
        opacity: 1;
        visibility: visible;
        height: 100%;
        display: block;
        margin: $sd-spacing-2 $sd-spacing-2 $sd-spacing-1 $sd-spacing-2;
      }
    }

    &__link::after {
      content: '';
      display: block;
      inset: 0;
      position: absolute;
    }
  }

  ui-cms-link {
    margin: $sd-spacing-4 0;
  }
}
